var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { useState, useEffect } from 'react';
import * as R from 'ramda';

export var useSpotlight = function useSpotlight(hasCommit) {
  var defaultTerm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var defaultSpotlight = arguments[2];
  var action = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

  var _useState = useState(defaultTerm),
      term = _useState[0],
      setTerm = _useState[1];

  var _useState2 = useState(defaultSpotlight),
      _useState2$ = _useState2[0],
      spotlight = _useState2$ === undefined ? {} : _useState2$,
      setSpotlight = _useState2[1];

  var _useState3 = useState(false),
      isFocus = _useState3[0],
      setFocus = _useState3[1];

  useEffect(function () {
    setTerm(defaultTerm);
    setSpotlight(defaultSpotlight);
  }, [defaultTerm, defaultSpotlight]);

  var onKeyPress = function onKeyPress(event) {
    if (event.key === 'Enter') return action({ term: term, spotlight: spotlight });
  };

  var onClearTerm = function onClearTerm(event) {
    event.preventDefault();
    setTerm('');
    return action({ term: '' });
  };

  var onChangeTerm = function onChangeTerm(event) {
    event.preventDefault();
    var newTerm = R.propOr('', 'value')(event.target);
    setTerm(newTerm);
    return hasCommit ? null : action({ term: newTerm, spotlight: spotlight });
  };

  var onCommitTerm = function onCommitTerm(event) {
    event.preventDefault();
    return action({ term: term, spotlight: spotlight });
  };

  var onChangeField = function onChangeField(field) {
    return function (event) {
      var _extends2;

      event.preventDefault();
      var newSpotlight = _extends({}, spotlight, {
        fields: _extends({}, spotlight.fields, (_extends2 = {}, _extends2[field.id] = _extends({}, field, { isSelected: !field.isSelected }), _extends2))
      });
      setSpotlight(newSpotlight);
      return action({ term: term, spotlight: newSpotlight });
    };
  };

  return {
    value: term,
    spotlight: spotlight,
    isFocus: isFocus,
    setFocus: setFocus,
    onKeyPress: onKeyPress,
    onClearTerm: onClearTerm,
    onChangeTerm: onChangeTerm,
    onChangeField: onChangeField,
    onCommitTerm: onCommitTerm
  };
};